<template>
  <div class="product-detail">
    <div class="detail-header">
      <el-button type="primary" size="small" circle @click="goBack">
        <i class="el-icon-back" />
      </el-button>
      <h2>商品销售详情</h2>
    </div>

    <!-- 商品基本信息 -->
    <div class="info-section">
      <h3>基本信息</h3>
      <div class="info-card">
        <div class="info-item">
          <span class="label">商品名称：</span>
          <span class="value">{{ productInfo.productName }}</span>
        </div>
        <div class="info-item">
          <span class="label">店铺：</span>
          <span class="value">{{ productInfo.shop }}</span>
        </div>
        <div class="info-item">
          <span class="label">条形码：</span>
          <span class="value">{{ productInfo.barcode }}</span>
        </div>
        <div class="info-item">
          <span class="label">商品类别：</span>
          <span class="value">{{ productInfo.category }}</span>
        </div>
        <div class="info-item">
          <span class="label">规格：</span>
          <span class="value">{{ productInfo.spec }}</span>
        </div>
      </div>
    </div>

    <!-- 销售数据统计 -->
    <div class="stats-section">
      <h3>销售数据</h3>
      <div class="stats-cards">
        <div class="stat-card">
          <div class="stat-label">销售单价(元)</div>
          <div class="stat-value">{{ productInfo.salesPrice }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">成本价(元)</div>
          <div class="stat-value">{{ productInfo.costPrice }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">销售数量</div>
          <div class="stat-value">{{ productInfo.quantity }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">销售金额(元)</div>
          <div class="stat-value">{{ productInfo.salesAmount }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">剩余库存</div>
          <div class="stat-value">{{ productInfo.stock }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">毛利率(%)</div>
          <div class="stat-value">{{ productInfo.grossMargin }}%</div>
        </div>
      </div>
    </div>

    <!-- 销售记录列表 -->
    <div class="record-section">
      <h3>销售记录</h3>
      <div class="table-container">
        <el-table :data="salesRecords" stripe size="small" class="record-table">
          <el-table-column prop="orderId" label="订单号" min-width="180" />
          <el-table-column prop="orderTime" label="订单时间" min-width="150" />
          <el-table-column
            prop="customerName"
            label="客户名称"
            min-width="120"
          />
          <el-table-column
            prop="salesQuantity"
            label="销售数量"
            min-width="100"
            align="right"
          />
          <el-table-column
            prop="salesPrice"
            label="销售单价(元)"
            min-width="120"
            align="right"
          />
          <el-table-column
            prop="totalAmount"
            label="总金额(元)"
            min-width="120"
            align="right"
          />
          <el-table-column
            prop="orderStatus"
            label="订单状态"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.orderStatus === '已完成' ? 'success' : 'warning'
                "
              >
                {{ scope.row.orderStatus }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 移动端销售记录卡片 -->
      <div class="mobile-records">
        <div
          v-for="(record, index) in salesRecords"
          :key="index"
          class="record-card"
        >
          <div class="record-header">
            <div class="order-id">{{ record.orderId }}</div>
            <el-tag
              :type="record.orderStatus === '已完成' ? 'success' : 'warning'"
              size="mini"
            >
              {{ record.orderStatus }}
            </el-tag>
          </div>
          <div class="record-content">
            <div class="record-item">
              <span class="label">订单时间：</span>
              <span class="value">{{ record.orderTime }}</span>
            </div>
            <div class="record-item">
              <span class="label">客户名称：</span>
              <span class="value">{{ record.customerName }}</span>
            </div>
            <div class="record-item">
              <span class="label">销售数量：</span>
              <span class="value">{{ record.salesQuantity }}</span>
            </div>
            <div class="record-item">
              <span class="label">销售单价：</span>
              <span class="value">{{ record.salesPrice }}元</span>
            </div>
            <div class="record-item">
              <span class="label">总金额：</span>
              <span class="value">{{ record.totalAmount }}元</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          size="small"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  data() {
    return {
      // 商品信息
      productInfo: {
        productName: '云梯铁牛 复合肥料高...',
        shop: '云梯云仓',
        barcode: 'YJTNFFHLGTZL25...',
        category: '农资/肥料/云梯铁牛',
        spec: '40kg/袋',
        salesPrice: 99.9,
        costPrice: 99.84,
        quantity: 3439,
        salesAmount: 343556.1,
        stock: 0,
        grossMargin: 0.06
      },
      // 销售记录
      salesRecords: [
        {
          orderId: 'ORD202401010001',
          orderTime: '2024-01-01 10:30:00',
          customerName: '张三',
          salesQuantity: 100,
          salesPrice: 99.9,
          totalAmount: 9990,
          orderStatus: '已完成'
        },
        {
          orderId: 'ORD202401020002',
          orderTime: '2024-01-02 14:20:00',
          customerName: '李四',
          salesQuantity: 200,
          salesPrice: 99.9,
          totalAmount: 19980,
          orderStatus: '已完成'
        },
        {
          orderId: 'ORD202401030003',
          orderTime: '2024-01-03 09:15:00',
          customerName: '王五',
          salesQuantity: 150,
          salesPrice: 99.9,
          totalAmount: 14985,
          orderStatus: '已完成'
        },
        {
          orderId: 'ORD202401040004',
          orderTime: '2024-01-04 16:45:00',
          customerName: '赵六',
          salesQuantity: 300,
          salesPrice: 99.9,
          totalAmount: 29970,
          orderStatus: '已完成'
        },
        {
          orderId: 'ORD202401050005',
          orderTime: '2024-01-05 11:20:00',
          customerName: '孙七',
          salesQuantity: 250,
          salesPrice: 99.9,
          totalAmount: 24975,
          orderStatus: '已完成'
        }
      ],
      // 分页数据
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  created() {
    // 初始化总条数
    this.total = this.salesRecords.length;
    // 获取商品ID并加载数据
    const productId = this.$route.params.id;
    this.loadProductData(productId);
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    loadProductData(productId) {
      // 模拟根据商品ID加载数据
      console.log('加载商品数据，ID：', productId);
      // 实际项目中这里会调用API获取数据
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    }
  }
};
</script>

<style scoped>
.product-detail {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.detail-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}

.detail-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

/* 信息部分 */
.info-section,
.stats-section,
.record-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.info-section h3,
.stats-section h3,
.record-section h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

/* 基本信息卡片 */
.info-card {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.info-item .label {
  font-size: 12px;
  color: #666;
}

.info-item .value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

/* 统计数据卡片 */
.stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.stat-card {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.stat-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #5470c6;
}

/* 销售记录表格 */
.table-container {
  overflow-x: auto;
}

.record-table {
  width: 100%;
  font-size: 12px;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
  font-size: 12px;
}

/* 移动端销售记录卡片 */
.mobile-records {
  display: none;
  gap: 15px;
}

.record-card {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.order-id {
  font-size: 12px;
  font-weight: bold;
  color: #333;
}

.record-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.record-item .label {
  color: #666;
}

.record-item .value {
  color: #333;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .product-detail {
    padding: 15px;
  }

  .detail-header {
    /* flex-direction: column; */
    /* align-items: flex-start; */
    gap: 10px;
  }

  .detail-header h2 {
    font-size: 18px;
  }

  .info-section,
  .stats-section,
  .record-section {
    padding: 12px;
  }

  .info-section h3,
  .stats-section h3,
  .record-section h3 {
    font-size: 14px;
  }

  .info-card {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .stats-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-card {
    padding: 12px;
  }

  .stat-value {
    font-size: 20px;
  }

  /* 隐藏表格，显示卡片 */
  .table-container {
    display: none;
  }

  .mobile-records {
    display: flex;
    flex-direction: column;
  }

  .pagination-container {
    justify-content: center;
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .product-detail {
    padding: 10px 0;
  }

  .stats-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
